export default {
  methods: {
    generateRandomString: function (len, alphanumericOnly = true) {
      let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      if (!alphanumericOnly) {
        chars += '~`! @#$%^&*()_-+={[}]|:;"\'<,>.?/\\'
      }

      let code = ''
      for (let i = 0; i < len; i++) {
        code += chars[Math.floor(Math.random() * chars.length)]
      }

      return code
    },

    generateId: function (len) {
      let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let code = ''
      for (let i = 0; i < len; i++) {
        code += chars[Math.floor(Math.random() * chars.length)]
      }
      return code
    },

    isJsonValid: function (data, allowEmpty = false) {
      try {
        if (typeof data === 'object') {
          return true
        }

        // database allow empty for valid JSON
        if (allowEmpty && data === '') {
          return true
        }

        JSON.parse(data)

        return true
      } catch (error) {
        // console.error(error)
        return false
      }
    },

    sanitizeMerchantToEmailName: function (emailName) {
      return emailName.replace(/[^a-zA-Z0-9_-]/g, '')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utility.js